import { FilterMenuConfig } from '../../types/filter.type';

export const SLOPE_FILTERS: FilterMenuConfig = {
  filters: [
    {
      type: 'range',
      unit: 'm',
    },
  ],
};

export const SLOPE_FILTER_HTTP_PARAM_NAMES: Record<string, string> = {
  min: 'minPositiveSlope',
  max: 'maxPositiveSlope',
};
